import i18n from '@/i18n'
import { resolveLeakDate } from '@/utils/leakDate'

export const STATUS_COLORS = {
  normal:   '#34d399',
  caution:  '#fbbf24',
  abnormal: '#f87171',
  delay:    '#6b7280',
}

// 상태 텍스트는 이제 i18n 에서 lookup — 활성 locale 에 따라 변경
//   STATUS_TEXT 객체는 후방 호환을 위해 getter 로 유지 (변경된 locale 자동 반영)
const STATUS_KEYS = {
  normal:   'dashboard.summary.normal',
  caution:  'dashboard.summary.caution',
  abnormal: 'dashboard.summary.alarm',
  delay:    'dashboard.summary.delay',
}
export const STATUS_TEXT = new Proxy({}, {
  get(_, key) {
    const k = STATUS_KEYS[key]
    return k ? i18n.global.t(k) : key
  },
})

export const STATUS_ORDER = {
  delay:    0,
  normal:   1,
  caution:  2,
  abnormal: 3,
}

function pressureStatus(d) {
  if (d.mnp == null || d.mnp === '') return 'delay'
  if (d.content != null && d.content !== '') return 'abnormal'
  const boundary = Number(d.ref_mnp_boundary ?? d.mnp_boundary)
  const mnp = Number(d.mnp)
  if (isFinite(boundary) && isFinite(mnp)) {
    if (mnp < boundary || mnp >= boundary + 2) return 'caution'
  }
  return 'normal'
}

function leakStatus(d) {
  if (d.wave_energy == null) return 'delay'
  // 오늘 이전 날짜 데이터는 아직 미확인으로 간주 — 통영(고객사 52) 최초 진입 조회는 날짜
  //   필터 없이 전체 이력을 받아오므로 과거 데이터가 섞여 들어올 수 있음
  const lastDate = String(d.last_measure_datetime || '').slice(0, 10)
  if (lastDate) {
    const now = new Date()
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
    // 통영(고객사 52) 는 누수음 수집시각이 13:00 — 당일 그 시각이 아직 안 지났으면 "오늘"
    //   기준을 전날로 취급 (leakDate.resolveLeakDate 와 동일 규칙)
    const cutoffDate = resolveLeakDate(today, '13')
    if (lastDate < cutoffDate) return 'delay'
  }
  if (typeof d._5days === 'string' && d._5days.slice(0, 5) === '1,1,1') return 'abnormal'
  // AI 판정 필드 — 원격 모니터링(m2_leak_1/list) 응답은 ai_leak_result, 누수탐지(get_geojson→leak_type) 응답은 leak_type 사용
  if (d.ai_leak_result === 'L' || d.leak_type === 'L') return 'caution'
  return 'normal'
}

export function getDeviceStatus(d) {
  if (!d) return 'delay'
  if (d.measure_type === 'leak') return leakStatus(d)
  return pressureStatus(d)
}

export function statusColor(st) { return STATUS_COLORS[st] || STATUS_COLORS.delay }
// isLeak — 누수음 지점의 caution(AI 판정=L) 은 일반 "주의" 대신 "누수의심"으로 표기 (누수탐지 모듈 전역 관례와 통일)
export function statusText(st, isLeak = false) {
  if (st === 'caution' && isLeak) return i18n.global.t('dashboard.summary.leak_caution')
  return STATUS_TEXT[st] || st
}
